'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// /app/data/stacks/shopify/app-bridge/production/deploys/673419/node_modules/react/react.js
// module id = 10
// module chunks = 0